import React, { useState, useEffect } from "react";
import { auth, firestore } from "../firebaseConfig";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { collection, query, where, getDocs, addDoc, doc, updateDoc, setDoc, getDoc } from "firebase/firestore";
import { useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { analytics } from "../firebaseConfig";
import { logEvent } from "firebase/analytics";
const SignUp = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [orgName, setOrgName] = useState("");
  const [orgId, setOrgId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const inviteId = new URLSearchParams(location.search).get("invite");
    logEvent(analytics, 'sign_up_page');
    if (inviteId) {
      const checkInvite = async () => {
        // const inviteQuery = query(collection(firestore, "invites"), where("__name__", "==", inviteId));
        // const inviteSnapshot = await getDocs(inviteQuery);
        const inviteDocRef = doc(firestore, "invites", inviteId);
        const inviteDocSnap = await getDoc(inviteDocRef);
        // console.log('got the data', inviteDocSnap.data())
        if (inviteDocSnap.exists()) {
          const inviteData = inviteDocSnap.data();
          setOrgId(inviteData.orgId);
          setEmail(inviteData.email)
          const orgRef = doc(firestore, "organizations", inviteData.orgId);
          const orgSnap = await getDocs(query(collection(firestore, "organizations"), where("__name__", "==", inviteData.orgId)));
          if (!orgSnap.empty) {
            setOrgName(orgSnap.docs[0].data().name);
          }
        }
      };
      checkInvite();
    }
  }, [location]);

  const handleSignUp = async (e) => {
    e.preventDefault();
    const inviteId = new URLSearchParams(location.search).get("invite");
    const userCredentialSignUp = await createUserWithEmailAndPassword(auth, email, password);
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    let finalOrgId = orgId;


    if (!orgId) {
      const orgRef = await addDoc(collection(firestore, "organizations"), {
        name: orgName,
        ownerId: userCredential.user.uid,
        members: [userCredential.user.uid],
      });
      finalOrgId = orgRef.id;
    }

    // await addDoc(collection(firestore, "users"), {
    //   uid: userCredential.user.uid,
    //   email,
    //   orgId: finalOrgId,
    //   role: orgId ? "member" : "admin",
    // });

    try {
      await setDoc(doc(firestore, "users", userCredential.user.uid), {
        uid: userCredential.user.uid,
        email,
        orgId: finalOrgId,
        role: orgId ? "member" : "admin",
      });
    } catch (e) {
      console.error("Error adding document: ", e);
    }


    if (inviteId) {
      await updateDoc(doc(firestore, "invites", inviteId), { status: "accepted" });
    }

    navigate("/");
  };

  return (
    <div className="max-w-md mx-auto bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg mt-8">
    <Helmet>
      <title>Create Your Account | AI Contract Manager</title>
      <meta
        name="description"
        content="Sign up to start using AI Contract Manager — a secure platform that helps your team automate contract extraction, summaries, and analysis."
      />
      <link rel="canonical" href="https://aicontractmanager.com/signup" />
      <meta property="og:title" content="Create Your Account | AI Contract Manager" />
      <meta
        property="og:description"
        content="Join Clairvoyant Inc.'s contract automation platform and streamline your organization's legal workflows today."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://aicontractmanager.com/signup" />
    </Helmet>
      <h2 className="text-2xl font-semibold mb-4 text-center text-blue-600 dark:text-blue-400">Sign Up</h2>
      <form onSubmit={handleSignUp} className="space-y-4">
        {orgId ? (<>
          <div>
            <label className="block text-gray-700 dark:text-gray-300">Organization Name</label>
            <input
              type="text"
              className="w-full p-2 border dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
              value={orgName}
              disabled={true}
            />
            </div><div>
            <input
              type="email"
              placeholder="Email"
              required
              className="w-full p-2 border dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
              value={email}
              disabled={true}
            // onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          </>
        ) : (<>
          <div>
            <label className="block text-gray-700 dark:text-gray-300">Organization Name</label>
            <input
              type="text"
              placeholder="Enter organization name"
              className="w-full p-2 border dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
              value={orgName}
              onChange={(e) => setOrgName(e.target.value)}
              required
            />
            </div><div>
            <input
              type="email"
              placeholder="Email"
              required
              className="w-full p-2 border dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          </>
        )}

        <input
          type="password"
          placeholder="Set Your Password"
          required
          className="w-full p-2 border dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white p-2 rounded">
          Sign Up
        </button>
      </form>
    </div>
  );
};

export default SignUp;
